import { Directive, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { CalendarEvent } from '../utils/CalendarEvent';
import * as dateFns from 'date-fns';
export class MonthCellDragDirective {

   day: any;

   event: CalendarEvent;

  
  newEvent: EventEmitter<{ event: CalendarEvent }> = new EventEmitter<{
    event: CalendarEvent;
  }>();

  
  updateEvent: EventEmitter<{ event: CalendarEvent }> = new EventEmitter<{
    event: CalendarEvent;
  }>();
constructor() { }
/**
 * @param {?} event
 * @return {?}
 */
onMouseDown(event) {
    this.event = {
      title: 'No title',
      start: dateFns.startOfDay(this.day.date),
      end: dateFns.endOfDay(this.day.date),
      color: 'red',
      allDay: true,
      isReservation: false
    };
    event.preventDefault();
    this.newEvent.emit({event: this.event});
  }
/**
 * @param {?} event
 * @return {?}
 */
onMouseEnter(event: Event) {
    if (this.event) {
      if (this.day.date <= this.event.start) {
        this.event.start = dateFns.startOfDay(this.day.date);
      }else {
        this.event.end = dateFns.endOfDay(this.day.date);
      }
      this.updateEvent.emit({event: this.event});
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[appMonthCellDrag]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'day': [{ type: Input },],
'event': [{ type: Input },],
'newEvent': [{ type: Output },],
'updateEvent': [{ type: Output },],
'onMouseDown': [{ type: HostListener, args: ['mousedown', ['$event'], ] },],
'onMouseEnter': [{ type: HostListener, args: ['mouseenter', ['$event'], ] },],
};
}

function MonthCellDragDirective_tsickle_Closure_declarations() {
/** @type {?} */
MonthCellDragDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MonthCellDragDirective.ctorParameters;
/** @type {?} */
MonthCellDragDirective.propDecorators;
/** @type {?} */
MonthCellDragDirective.prototype.day;
/** @type {?} */
MonthCellDragDirective.prototype.event;
/** @type {?} */
MonthCellDragDirective.prototype.newEvent;
/** @type {?} */
MonthCellDragDirective.prototype.updateEvent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
